import { registerTaxIdValidator } from "./tax-id.js";
/**
 * Poland's tax identifier. One country's implementation of `TaxId`, registered
 * rather than special-cased, so adding another country is a new file and not an
 * edit to the parser.
 */
const NIP_LENGTH = 10;
const CHECKSUM_WEIGHTS = [6, 5, 7, 2, 3, 4, 5, 6, 7];
/**
 * Weighted sum modulo 11. A remainder of 10 can never be a valid check digit,
 * so such numbers are rejected rather than truncated to a single character.
 */
export function hasValidNipChecksum(value) {
    if (value.length !== NIP_LENGTH || !/^\d{10}$/.test(value))
        return false;
    let sum = 0;
    for (let i = 0; i < CHECKSUM_WEIGHTS.length; i++) {
        const weight = CHECKSUM_WEIGHTS[i];
        const digit = value.codePointAt(i);
        if (weight === undefined || digit === undefined)
            return false;
        sum += weight * (digit - 48);
    }
    const remainder = sum % 11;
    if (remainder === 10)
        return false;
    return remainder === Number(value[NIP_LENGTH - 1]);
}
registerTaxIdValidator("PL", hasValidNipChecksum);
//# sourceMappingURL=nip.js.map